window['job_ads#new'] =
  window['job_ads#edit'] =
  window['job_ads#clone'] = function () { }
